import React, { useContext, useState } from "react";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import { useNavigate, useParams } from "react-router-dom";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import { format } from "date-fns";
import CryptoJS from "crypto-js";
import { PassengerAPI } from "../../../../API/PassengerAPIs/PassengerAPIs";
import ApiResponseHandler from "../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import { EmergencyAPIs } from "../../../../API/EmergencyAPIs/EmergencyAPIs";

export default function EmergencyPaymentForm({emergencyData, date}){

    const routeParams = useParams();
    const [chargetotal, setChargeTotal] = useState(emergencyData.amount);
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [sending, setSending] = useState(false);
  

    const authenticateTransaction = "true";
    const checkoutoption = "combinedpage";
    const currency =	emergencyData.currency.code === "GBP" ? "826" : "978";
    const customParam_bookingId = emergencyData.bookingId;
    const customParam_dateofbirth = 'EMERGENCY PAYMENT';
    const customParam_emailaddress = emergencyData.email;
    const customParam_gender = 'N/A';
    const customParam_passengerid = 0;
    const customParam_schoolname = emergencyData.schoolName;
    const customParam_studentname = 'EMERGENCY PAYMENT';
    const hash_algorithm = process.env.REACT_APP_HASH_ALGO;
    const mode = "payonly";
    const oid = 'EP-'+format(new Date(date), "T");
    const responseFailURL = process.env.REACT_APP_RESPONSE_URL;
    const responseSuccessURL = process.env.REACT_APP_RESPONSE_URL;
    const sharedsecret = process.env.REACT_APP_SHARED_SECRET;
    const storename =	process.env.REACT_APP_STORE_ID;
    const timezone = "Europe/Dublin";
    const transactionNotificationURL = "N/A";
    const trxOrigin = "ECI";
    const txndatetime = format(new Date(date), "yyyy:LL:dd-HH:mm:ss");
    const txntype = "sale";

        
    const generateHashExtended = () => {
        let stringToExtendedHash = `${authenticateTransaction}|${chargetotal}|${checkoutoption}|${currency}|${customParam_bookingId}|${customParam_dateofbirth}|${customParam_emailaddress}|${customParam_gender}|${customParam_passengerid}|${customParam_schoolname}|${customParam_studentname}|${hash_algorithm}|${mode}|${oid}|${responseFailURL}|${responseSuccessURL}|${storename}|${timezone}|${transactionNotificationURL}|${trxOrigin}|${txndatetime}|${txntype}`;
        const hashHMACSHA256 = CryptoJS.HmacSHA256(stringToExtendedHash, sharedsecret)
        const hashExtended = CryptoJS.enc.Base64.stringify(hashHMACSHA256);
        return hashExtended;
    }

    const setLinkAsUsed = () => {

        EmergencyAPIs.PostUseNewPortalEmergencyLink(routeParams.emergencyPaymentCode)
        .then((response) => {
            if(response.status === 200){
                document.getElementById("paymentForm").method = "POST";
                document.getElementById("paymentForm").action = process.env.REACT_APP_AUTHIPAY_URL;
                document.getElementById("paymentForm").submit();
            }
        })
        .catch((err) => {
            console.log(err);
            setSending(false);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    const handleSubmit = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        if(sending) return;

        setSending(true);


        const postJSON = {
            paymentOrderId: oid,
            payerId: 0,
            passengerId: 0,
            transactionAttemptedTime: date,
            transactionAmount: chargetotal,
            currency: emergencyData.currency.code,
            bookingId: emergencyData.bookingId,
            // portalPaymentId: 405,
            portalTransactionId: 0,
            transactionStatus: 0
        }

        // document.getElementById("paymentForm").method = "POST";
        // document.getElementById("paymentForm").action = process.env.REACT_APP_AUTHIPAY_URL;
        // document.getElementById("paymentForm").submit();

        

        PassengerAPI.PostPaymentSession(postJSON)
        .then((response) => {
            if(response.status === 200){
                // document.getElementById("paymentForm").method = "POST";
                // document.getElementById("paymentForm").action = process.env.REACT_APP_AUTHIPAY_URL;
                // document.getElementById("paymentForm").submit();
                setLinkAsUsed();
            }
        })
        .catch((err) => {
            console.log(err);
            setSending(false);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })

        
    }


    return(
        // <form method="POST" action={process.env.REACT_APP_AUTHIPAY_URL}>
        <form id='paymentForm' onSubmit={handleSubmit}>
            <input name="checkoutoption" type="hidden" value={checkoutoption} readOnly/>
            <input name="currency" type="hidden" value={currency} readOnly/>
            <input name="customParam_bookingId" type="hidden" value={customParam_bookingId} readOnly/>
            <input name="customParam_dateofbirth" type="hidden" value={customParam_dateofbirth} readOnly/>
            <input name="customParam_emailaddress" type="hidden" value={customParam_emailaddress} readOnly/>
            <input name="customParam_gender" type="hidden" value={customParam_gender} readOnly/>
            <input name="customParam_passengerid" type="hidden" value={customParam_passengerid} readOnly/>
            <input name="customParam_schoolname" type="hidden" value={customParam_schoolname} readOnly/>
            <input name="customParam_studentname" type="hidden" value={customParam_studentname} readOnly/>
            <input name="hashExtended" type="hidden" value={generateHashExtended()} readOnly/>
            <input name="hash_algorithm" type="hidden" value={hash_algorithm} readOnly/>
            <input name="mode" type="hidden" value={mode} readOnly/>
            <input name="oid" type="hidden" value={oid} readOnly/>
            <input name="responseFailURL" type="hidden" value={responseFailURL} readOnly/>
            <input name="responseSuccessURL" type="hidden" value={responseSuccessURL} readOnly/>
            <input name="transactionNotificationURL" type="hidden" value={transactionNotificationURL} readOnly/>
            <input type="hidden" name="authenticateTransaction" value={authenticateTransaction}/>
            <input name="storename" type="hidden" value={storename} readOnly/>
            {/* <input name="paymentMethod" type="hidden" value={paymentMethod} readOnly/> */}
            <input name="timezone" type="hidden" value={timezone} readOnly/>
            <input name="txndatetime" type="hidden" value={txndatetime} readOnly/>
            <input name="txntype" type="hidden" value={txntype} readOnly/>
            <input name="trxOrigin" type="hidden" value={trxOrigin} readOnly/>
            <input name="chargetotal" type="hidden" value={chargetotal} readOnly/>
            {/* Amount:<p/> */}
            <STC.InputGroup>
            <STC.Form.Control disabled required name="chargetotal" type="number" step={"0.01"}  value={chargetotal} onChange={(e) => setChargeTotal(e.target.value)} />
            <STC.Button type="submit"  disabled={sending}>Pay now</STC.Button>
            </STC.InputGroup>
        </form>
    )
}